function headerScroll(){
    var scrollPosition = window.scrollY;
    var body = document.body;;

    window.addEventListener('scroll', function() {

        scrollPosition = window.scrollY;

        if (scrollPosition >= 30) {
            body.classList.add('scrolled-header');
        } else {
            body.classList.remove('scrolled-header');
        }

    });
}

export default headerScroll;